import {RefObject} from "react";
import css from "../mjbc-2026.module.scss";

interface BootPanelProps {
    /** The fill's width is driven directly on the node, not through props. */
    fillRef: RefObject<HTMLSpanElement | null>;
    label: string;
    valueNow: number;
}

/**
 * Frames 1-4. The four drawn frames differ only by how far the bar has filled
 * and which label is showing, so they collapse into one screen.
 */
export default function BootPanel({fillRef, label, valueNow}: BootPanelProps) {
    return (
        <section className={`${css.panel} ${css.bootPanel}`} aria-live="polite">
            <p className={css.bootLabel}>{label}</p>
            <div
                className={css.progressTrack}
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={valueNow}
                aria-label="Establishing link"
            >
                <span ref={fillRef} className={css.progressFill} style={{width: 0}}/>
            </div>
        </section>
    );
}
